import(/* webpackMode: "eager" */ "/app/node_modules/@livekit/components-styles/dist/general/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@livekit/components-styles/dist/general/prefabs/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.css");
